import { gql } from '@apollo/client'

const CALENDAR_OCCURRENCE_FIELDS = `
  title
  subtitle
  startDateTime
  endDateTime
  participantName
  event {
    __typename
    ... on Session {
      id
      isCanceled
      lessonType {
        id
        title
        category
      }
      enrollments {
        id
        isCanceled
        student {
          id
          firstName
          lastName
        }
      }
    }
    ... on GroupEvent {
      id
      isCanceled
      slug
      enrollments {
        id
        isCanceled
        student {
          id
          firstName
          lastName
        }
      }
    }
    ... on CoachAvailabilityBlockTime {
      id
      blockNote
    }
    ... on GoogleCalendarBusyTime {
      startTime
      endTime
    }
  }
`

/** Coach picker: academy metadata + employments (id, name, role). */
export const ACADEMY_SCHEDULE_COACHES_QUERY = gql`
  query AcademyScheduleCoaches($academyId: ID!) {
    academy(id: $academyId) {
      id
      name
      slug
      employments {
        role
        coach {
          id
          name
          coachProfile {
            profilePhoto
          }
        }
      }
    }
  }
`

/** Per-coach schedule layer: calendar occurrences for the visible range. */
export const COACH_SCHEDULE_LAYER_QUERY = gql`
  query CoachScheduleLayer(
    $coachId: ID!
    $from: ISO8601DateTime!
    $to: ISO8601DateTime!
  ) {
    coach(id: $coachId) {
      id
      calendar(timespan: { from: $from, to: $to }) {
        ${CALENDAR_OCCURRENCE_FIELDS}
      }
    }
  }
`

export const COACH_SETTINGS_QUERY = gql`
  query CoachSettings($coachId: ID!) {
    coach(id: $coachId) {
      id
      bookingLimit
      bookingCutoff
      preferences {
        canStudentCancel
        bookNowEnabled
      }
      facilities(withAvailability: true) {
        id
        name
        timezone
        availabilities {
          id
          startDate
          timeSlots {
            day
            startTime
            endTime
          }
        }
      }
    }
  }
`
